export default "__VITE_ASSET__CnJUZGyX__"